import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { LabManagerService } from '../lab-manager.service';
import { LabManagerSharedDataService } from '../lab-manager-shared-data.service';
import { MatTableDataSource } from '@angular/material/table';
import { LabSubmissionDetailsModel } from 'src/app/models/lab-manager/lab-submission-details';

@Component({
  selector: 'app-lab-soil-results-table',
  templateUrl: './lab-soil-results-table.component.html',
  styleUrl: './lab-soil-results-table.component.css',
  standalone: false
})
export class LabSoilResultsTableComponent {
  sampleSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  labSubmissionDetails: LabSubmissionDetailsModel;
  searchText: string = '';
  pageSize: number = 9999;
  currentPage: number = 0;
  totalElements: number = 0;
  sampleColumns = [
    'farm',
    'field',
    'sample',
    'sampleReference',
    'rockPercentage',
    'sampleDepth',
    'blank',
    'batchNum',
    'textureClay',
    'textureSilt',
    'textureSand',
    'textureCode',
    'eksteen',
    'phKcl',
    'cl',
    'potassium',
    'calcium',
    'magnesium',
    'sodium',
    'ohms',
    'carbon',
    'sulphur',
    'traceCu',
    'traceZn',
    'traceMn',
    'traceB',
    'traceFe',
    'nh4',
    'no3',
    'density',
    'gf',    
    'kme',
    'caMe',
    'mgMe',
    'naMe',
    'svalue',
    'tvalue',
    'bvPercentage',
    'caSatPercentage',
    'mgSatPercentage',
    'naSatPercentage',
    'ksatPercentage',
    'cedara',
    'vrykalk',
    'pbray1',
    'pbray2',
    'olsenGrouped',
    'mehlichIii',
    'citricAcid',
    'ambic'
  ];
  

  constructor(
    private nav: NavBarComponent,
    private labManagerService: LabManagerService,
    private labManagerSharedDataService: LabManagerSharedDataService
  ) {
  
    // See lab-manager.component.ts: these subscriptions used to outlive the component.
    labManagerSharedDataService.labSubmissionDetailsData$.pipe(takeUntilDestroyed()).subscribe(res => {
      if(res) {
       // console.log(res)
        this.labSubmissionDetails = res;
        this.retrieveLabResults();
      }
    })
  }

  textureValues: any[] = [];
  showErrorNotes = false;
  ngOnInit(): void {
    this.labManagerService.getSoilTextureValues().subscribe(values => this.textureValues = values);
    
  }

  retrieveLabResults() {
    this.nav.toggleLoading(true);
    this.labManagerService.getSoilLabResults(this.labSubmissionDetails.id, this.currentPage, this.pageSize).subscribe({
      next: (res) => {
        //console.log(res);
        this.nav.toggleLoading(false);
        this.sampleSource = new MatTableDataSource<any>(res.content);
        this.totalElements = res.totalElements;
      },
      error: () => {
        this.nav.toggleLoading(false);
      }
    })
  }

  onPaginateChange(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.retrieveLabResults();
  }
}
